import {
  Droplets,
  Eye,
  Flame,
  HardHat,
  Leaf,
  ShieldAlert,
  TriangleAlert,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { ReportTypeIcon } from '@up2d8/contracts';

/**
 * Het icoon van een soort melding (VLR-4): op de tegel van het meldscherm en in het beheer.
 *
 * Gedeeld omdat de beheerder moet zien wat de medewerker straks ziet; twee lijsten zouden uit
 * elkaar lopen bij het eerste icoon dat erbij komt.
 */
export const REPORT_TYPE_ICONS: Record<ReportTypeIcon, LucideIcon> = {
  triangle: TriangleAlert,
  shield: ShieldAlert,
  wrench: Wrench,
  flame: Flame,
  droplet: Droplets,
  zap: Zap,
  hardhat: HardHat,
  leaf: Leaf,
  eye: Eye,
};

export const REPORT_TYPE_ICON_KEYS = Object.keys(REPORT_TYPE_ICONS) as ReportTypeIcon[];
